<script setup lang="ts">
import {
  RadioGroup,
  RadioGroupLabel,
  RadioGroupOption,
} from '@headlessui/vue'

type RadioItem = {
  id: string,
  label: string
}

const props = defineProps<{
  modelValue: string
  options: RadioItem[]
}>()

const toggle = computed({
      get () {
        return props.modelValue
      },
      set (value) {
        emit('update:modelValue', value)
      }
    })

const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <div>
    <div class="mx-auto w-full max-w-md">
      <RadioGroup :value="modelValue" v-model="toggle">
        <div class="flex flex-col xl:flex-row bg-neutral-100 rounded-xl p-1 xl:rounded-full xl:p-0.5">
          <RadioGroupOption
            as="template"
            v-for="(option, index) in options"
            :key="index"
            :value="option.id"
            v-slot="{ checked }"
          >
            <div
              :class="[
                checked ? 'bg-black text-white ' : '',
              ]"
              class="relative flex cursor-pointer rounded-full focus:outline-none px-2"
            >
              <div class="flex w-full items-center justify-between">
                <div class="flex items-center">
                  <div class="text-sm">
                    <RadioGroupLabel
                      as="p"
                      :class="checked ? 'text-white' : 'text-gray-900'"
                      class="font-medium whitespace-nowrap"
                    >
                      {{ option.label }}
                    </RadioGroupLabel>
                  </div>
                </div>
              </div>
            </div>
          </RadioGroupOption>
        </div>
      </RadioGroup>
    </div>
  </div>
</template>
